import CoursePage from './page';
import { RouterConfig } from 'router/AppRoute';
import paths from 'helper/pathRoutes';

const routes: RouterConfig[] = [
  {
    path: paths.course_manager,
    page: CoursePage,
  },
];

export default routes;
